module.exports = __webpack_public_path__ + "img/icon-pdf.4ba14fe4.png";